import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
const certifications = [{
  organization: 'IICRC',
  title: 'Water Restoration Technician, Fire Restoration Technician',
  period: 'Jan 2011 - Present',
  association: 'AdvantaClean of Greater Hartford CT',
  logo: 'https://www.google.com/s2/favicons?domain=iicrc.org&sz=128',
  fallbackLogo: 'https://logo.clearbit.com/iicrc.org'
}, {
  organization: 'MICRO',
  title: 'Certified Mold Inspector & Certified Mold Remediator',
  period: 'Jan 2011 - Present',
  association: 'AdvantaClean of Greater Hartford CT',
  logo: 'https://www.google.com/s2/favicons?domain=moldinspector.com&sz=128',
  fallbackLogo: 'https://logo.clearbit.com/moldinspector.com'
}];
export function Certifications() {
  return <section className="py-20 bg-[#FDFBF7]" data-id="element-105">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-107">
          <h2 className="text-2xl md:text-3xl font-bold text-corporate-blue mb-4" data-id="element-108">
            Certifications
          </h2>
          <div className="w-20 h-1 bg-corporate-teal rounded-full" data-id="element-109"></div>
        </motion.div>

        <div className="space-y-6 max-w-3xl" data-id="element-110">
          {certifications.map((cert, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-corporate-blue flex items-start gap-5" data-id="element-111">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 mt-0.5 bg-white border border-[#E8E0D0] overflow-hidden p-1.5" data-id="element-112">
                <img src={cert.logo} alt={`${cert.organization} logo`} className="w-full h-full object-contain" onError={e => {
              const target = e.target as HTMLImageElement;
              if (cert.fallbackLogo && target.src !== cert.fallbackLogo) {
                target.src = cert.fallbackLogo;
              } else {
                target.style.display = 'none';
                const parent = target.parentElement;
                if (parent) {
                  parent.classList.add('bg-corporate-blue/10');
                  parent.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-corporate-blue"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"/><path d="m9 12 2 2 4-4"/></svg>';
                }
              }
            }} data-id="element-113" />
              </div>
              <div className="flex-1" data-id="element-114">
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-1" data-id="element-115">
                  <div data-id="element-116">
                    <span className="text-xs font-bold text-corporate-teal uppercase tracking-wider" data-id="element-117">
                      {cert.organization}
                    </span>
                    <h3 className="text-base font-bold text-corporate-blue leading-snug mt-1" data-id="element-118">
                      {cert.title}
                    </h3>
                  </div>
                  <span className="text-sm text-[#9A9184] font-medium bg-[#F0EBE1] px-3 py-1 rounded-full flex-shrink-0 whitespace-nowrap" data-id="element-119">
                    {cert.period}
                  </span>
                </div>
                <p className="text-[#6B6356] text-sm mt-2" data-id="element-120">
                  Associated with{' '}
                  <span className="font-medium text-[#4A4438]" data-id="element-121">
                    {cert.association}
                  </span>
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}